import { render, staticRenderFns } from "./TableCostCafezal.vue?vue&type=template&id=68ac239e"
import script from "./TableCostCafezal.vue?vue&type=script&lang=js"
export * from "./TableCostCafezal.vue?vue&type=script&lang=js"
import style0 from "./TableCostCafezal.vue?vue&type=style&index=0&id=68ac239e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports